export const Labels = {
  SEARCH_THE_KB: "Search the full knowledge base for ",
  ASK_ABOUT_PAGE: "Ask a question about this page",
  ASK_ABOUT_VIDEO: "Ask a question about this video",
  SUMMARIZE: "Summarize",
  LISTENING: "Listening...",
  SEARCH: "Ask a question or describe your issue",
  SEARCH_MOBILE: "Ask a question",
  SEARCH_HEB: "מה תרצו לדעת ?",
  NO_SUMMARY: "Apologies, could not summarize",
  NO_ANSWER: "No answer was found. Please rephrase or ",
  MORE_RESULTS: "More results",
};
